export default function TeamSettings() {
  return (
    <section className="flex flex-col gap-4 align-middle items-center">
      <h1>Settings Page</h1>
      <p>Coming Soon</p>
    </section>
  );
}
